import { gql } from "@apollo/client";

/** Event ticketing settings (step 1) plus what the checks need. */
export const GET_SETUP_EVENT = gql`
  query setup_event($id: Int!) {
    events_by_pk(id: $id) {
      id
      name
      is_active
      organization_id
      description
      payment_processor_id
      location_zones
      ticketing_slug
      ticketing_logo
      ticketing_background_url
      ticketing_payment_processor_id
      ticketing_service_fee_per_order
      web_surcharge_percentage
      ticketing_configurations
      ticketing_payment_processor_config {
        id
        processor
        payment_processor
        is_active
        config
      }
    }
  }
`;

export const GET_SETUP_PROCESSORS = gql`
  query setup_processors($where: payment_processor_config_bool_exp) {
    payment_processor_config(where: $where, order_by: { id: asc }) {
      id
      processor
      payment_processor
      is_active
      is_rfid
      config
    }
  }
`;

export const GET_SETUP_TICKETS = gql`
  query setup_tickets($eventId: Int!) {
    items_ticketing(where: { event_id: { _eq: $eventId } }, order_by: [{ sort_order: asc }, { name: asc }]) {
      id
      event_id
      name
      price
      tax_percentage
      category
      description
      additional_email_description
      is_active
      available_public_sale
      cashless_top_up_item
      sales_limit
      sales_limit_balance
      order_quantity_limit
      unlimited_ingress
      include_egress
      include_pos_tokens
      pos_token_payload
      token_payload
      included_cash_balance
      included_promo_balance
      tab_id
      sort_order
      modifiers
      updated_at
      tab {
        id
        name
        sort_order
        is_active
      }
    }
  }
`;

export const GET_SETUP_GATES = gql`
  query setup_gates($eventId: Int!) {
    locations(where: { event_id: { _eq: $eventId }, is_active: { _eq: true } }, order_by: { name: asc }) {
      id
      name
      location_type
      zone
      vendor_id
      redeemable_tokens
    }
  }
`;

export const UPDATE_ITEMS_TICKETING_MANY = gql`
  mutation setup_update_items_many($updates: [items_ticketing_updates!]!) {
    update_items_ticketing_many(updates: $updates) {
      affected_rows
    }
  }
`;
